<template>
  <div class="max-w-5xl m-auto">
    <orders-details />
  </div>
</template>
<script>
import '@pagarme/orders-details/web-comp'

export default {
  name: 'OrdersDetail'
}
</script>
